import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { IServiceProviderSearchParameters } from 'src/app/Models/IServiceProviderSearchParameters';

@Component({
  selector: 'app-_500_ProgressReport',
  templateUrl: './_500_ProgressReport.component.html',
  styleUrls: ['./_500_ProgressReport.component.css']
})

export class _500_ProgressReportComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; //datepicker
  startDate: Date; endDate: Date; //date range
  selectedPAU: SelectItem;
  selectedSite: SelectItem;
  selectedServiceProvider: SelectItem;
  _PAUid: string = null; _siteId: string = null; _serviceProvider: string = null;
  public showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }];
  lookupSProvidersList: ILookupBase[] = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
    this.date = new Date();
    this.endDate = new Date();
  }


  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.startDate = this._myGlobals.schoolYearStartDate;
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
        this.selectedPAU = this.lookupPAUList[0];
        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              this.getProviderList();
            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];

          this.getProviderList();
        }
      },
        err => console.error(err)
      );
  }

  setSite(id): void {
    this._siteId = id.value;

    this.getProviderList();
  }

 
  selectServiceProvider(id): void { this._serviceProvider = id.value }

  getProviderList() {
    let startDate = this.date;
    let endDate = this.date

    //Service Provider Lookup
    let serviceProviderParams: IServiceProviderSearchParameters = {} as IServiceProviderSearchParameters;
    serviceProviderParams.startDate = startDate
    serviceProviderParams.endDate = endDate
    serviceProviderParams.siteIdArray = this.getSiteIdList().split('^');


    this._lookupService.getLookupServiceProviders(this._baseUrl + 'api/Lookup/GetServiceProviderList/', serviceProviderParams)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSProvidersList = [{ value: null, label: "-- NO SERVICE PROVIDERS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSProvidersList = [{ value: null, label: "-- ALL Service Providers --", shortText: null, updatedOn: null }].concat(res);
          this.selectedServiceProvider = this.lookupSProvidersList[0];
        }
      },
        err => console.error(err)
      );
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }


  viewReport() {
    this.showSpinner = true;
    let reportParamArray: IReportParameter[] = [];
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    var selectedServiceProvider = this.lookupSProvidersList.find(z => z.value === this._serviceProvider).label;
    var serviceProviderStaffIdList: string = '';
    var j = this.lookupSProvidersList.length;

    if (selectedServiceProvider == "-- ALL Service Providers --") {
      if (j > 1) {
        for (var i = 1; i < j; i++) {
          serviceProviderStaffIdList += this.lookupSProvidersList[i].value + '^';
        }
        serviceProviderStaffIdList = serviceProviderStaffIdList.slice(0, serviceProviderStaffIdList.length - 1).replace('undefined', '');
      }
    }
    else {
      serviceProviderStaffIdList = this.lookupSProvidersList.find(z => z.value === this._serviceProvider).value;
    }

    reportParamArray.push(
      { parameterName: 'StartDate', parameterValue: this.startDate != null ? this.startDate.toISOString().slice(0, 10) : '7/1/2025' },
      { parameterName: 'EndDate', parameterValue: this.endDate != null ? this.endDate.toISOString().slice(0, 10) : this.date.toISOString().slice(0, 10) },
      { parameterName: 'PAU_Name', parameterValue: (this.selectedPAU != null && selectedPAUValue != '-- ALL PAUs --') ? selectedPAUValue : 'All PAUs' },
      { parameterName: 'SiteName', parameterValue: (this.selectedSite != null && selectedSiteValue != "-- Select PAU to view sites --") ? selectedSiteValue.replace('-- ', '').replace(' --', '') : 'All Sites' },
      { parameterName: 'ServiceProviderName', parameterValue: (this.selectedServiceProvider != null && selectedServiceProvider != "-- ALL Service Providers --") ? selectedServiceProvider : 'All Service Providers' },
      { parameterName: 'SiteIdList', parameterValue: this.getSiteIdList().replace('undefined', '') },
      { parameterName: 'ServiceProviderStaffIdList', parameterValue: serviceProviderStaffIdList != null ? serviceProviderStaffIdList.replace('null', '') : '' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' }
    );

    let now = new Date();
    let localReportFileName = '500-ProgressReportByDate_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "IEP_ProgressReport_ByDate";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
